import { getByPathPriority } from './getByPathPriority';

const getErrorMessage = (messages, key, params) => {
    const regx = /{(.*?)}/g;
    return getByPathPriority(messages, [key], 'Ошибка валидации').replace(regx, (_, key) => getByPathPriority(params, [key], ''));
};

/**
 * Для каждого поля вернет список человекочитаемых ошибок валидации в поле `activeErrorMessages`
 *
 * @param {Object.<string, string>} messages - объект с человекочитаемым описанием ошибки
 * @param {object} validator - объект `this.$v` валидатора компонента
 */
export const extractVuelidateErrors = (messages, validator) => {
    const errors = {};
    const activeErrorMessages = {};

    validator.$errors.forEach((error) => {
        const key = error.$propertyPath;
        const validatorKey = error.$validator;
        errors[key] = error;

        if (!Array.isArray(activeErrorMessages[key])) activeErrorMessages[key] = [];
        activeErrorMessages[key].push({
            key: validatorKey,
            title: getErrorMessage(messages, validatorKey, error.$params),
        });
    });

    return {
        errors,
        activeErrorMessages,
    };
};
